import { EvmNFTChain, MarketplaceConfigUrls } from '@repo/types-client';

import { baseMarketplaceConfig } from './base';
import { ethereumMarketplaceConfig } from './ethereum';

export const evmMarketplaceConfig: Readonly<
  Record<Exclude<EvmNFTChain, 'external-base'>, MarketplaceConfigUrls>
> = {
  base: baseMarketplaceConfig,
  ethereum: ethereumMarketplaceConfig,
};
